import {Component, OnInit} from '@angular/core';
import {InviteManagementService} from './invite-management.service';
import {
  InvitePolicy,
  InviteManagementModel,
  UpdateMembersMaxInvites,
  GenerateInviteCodes
} from './invite-management.model';

import 'rxjs/Rx';
import {EnumModel} from '../../shared/objects/EnumModel';
import {StatisticDataModel} from '../../shared/objects/statistics-group.model';
import {ToasterService} from "angular2-toaster";

@Component({
  selector: 'app-invite-management',
  providers: [InviteManagementService],
  templateUrl: './invite-management.component.html',
  styleUrls: ['./invite-management.component.less']
})
export class InviteManagementComponent implements OnInit {
  inviteManagementModel = new InviteManagementModel();
  membersMaxInvitesModel = new UpdateMembersMaxInvites();
  generateInviteCodesModel = new GenerateInviteCodes();

  invitePoliciesModel: InvitePolicy[];
  statisticModel: StatisticDataModel[];
  // Code Generator
  membershipTypesOptions = new Array<EnumModel>();
  membershipDurationOptions = Array<EnumModel>();
  numberOfCodesToGenerate = 1;
  // Selected values
  selectedMembershipDuration = new EnumModel();
  selectedMembershipTypes = new EnumModel();
  checkedInvitePolicy = '';

  number: any;

  constructor(private inviteManagementService: InviteManagementService, private toasterService: ToasterService) {
  }

  ngOnInit() {
    this.inviteManagementService.getInviteManagement()
      .subscribe(response => {
          this.inviteManagementModel = response;
          for (let i = 0; i < this.inviteManagementModel.membershipTypes.length; i++) {
            this.membershipTypesOptions.push(
              new EnumModel(this.inviteManagementModel.membershipTypes[i].id, this.inviteManagementModel.membershipTypes[i].name));
          }
          for (let i = 0; i < this.inviteManagementModel.premiumExpiryDates.length; i++) {
            this.membershipDurationOptions.push(
              new EnumModel(this.inviteManagementModel.premiumExpiryDates[i].id, this.inviteManagementModel.premiumExpiryDates[i].name));
          }

          this.invitePoliciesModel = this.inviteManagementModel.invitePolicies;
          for (const item of this.inviteManagementModel.membershipTypes) {
            if (item.id === this.inviteManagementModel.membershipTypes[0].id) {
              this.selectedMembershipTypes = new EnumModel(item.id, item.name);
              break;
            }
          }
          for (const item of this.inviteManagementModel.premiumExpiryDates) {
            if (item.id === this.inviteManagementModel.premiumExpiryDate) {
              this.selectedMembershipDuration = new EnumModel(item.id, item.name);
              break;
            }
          }
          this.checkedInvitePolicy = this.inviteManagementModel.invitePolicy;
          this.statisticModel = this.inviteManagementModel.inviteAnalitics;
        }
      );
  }


  confirmAppInvites(number) {
    this.membersMaxInvitesModel.membersMaxInvites = number;
    console.log(this.membersMaxInvitesModel);
    this.inviteManagementService.updateMembersMaxInvites(this.membersMaxInvitesModel)
      .subscribe(
        (response => this.toasterService.pop({
          type: 'success',
          title: 'Success',
          body: 'App invites number saved.',
          showCloseButton: true,
          timeout: 3000
        })),
        (error) => this.toasterService.pop({
          type: 'error',
          title: 'Error',
          body: error.message,
          showCloseButton: true,
          timeout: 5000
        })
      );
  }

  codeGenerate(memberType, memberDuration, numberOfCodes) {
    this.generateInviteCodesModel.membershipType = memberType.id;
    this.generateInviteCodesModel.premiumExpiryDate = memberDuration.id;
    this.generateInviteCodesModel.numberOfCodesToGenerate = numberOfCodes;

    this.inviteManagementService.generateInviteCodes(this.generateInviteCodesModel)
      .subscribe(
        response => {
          this.exportData(response);
        },
        (error => console.log(error))
      );
  }

  exportData(data) {
    const blob = data;
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'generateCode.xls';
    document.body.appendChild(a);
    a.click();
  }

  setInvitePolicy(value) {
    if (this.checkedInvitePolicy === value) {
      return;
    }
    this.checkedInvitePolicy = value;

    this.inviteManagementService.updateInvitePolicy(value)
      .subscribe(
        (response) => console.log(response),
        (error) => console.log(error)
      );
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/invite-management/invite-management.component.ts